<style type="text/css">
    .viewTable {
        width: 100%;
        padding: 10px;
        border-collapse: collapse;
        margin-bottom: 5px;
    }

    .viewTable td {
        border: 1px solid #80808026;
        padding: 8px !important;
        font-size: 13px;
        font-weight: 400;
    }
</style>
<template>
    <v-card>
        <v-toolbar color="primary" dark>
            <v-toolbar-title>{{label}}</v-toolbar-title>
        </v-toolbar>
        <table class="viewTable" v-for="object in items">
            <tr v-for="(vl,key) in object">
                <td style="text-align: right;font-weight:bold;width: 30%">{{key}}</td>
                <td style="width: 70%">{{formatData(vl)}}</td>
            </tr>
        </table>
    </v-card>
</template>

<script>
    import Validator from "../../../public/js/validator";
    import FormJS from "../../../public/plugin/form/form";
    import DateUtils from "../../../public/js/DateUtils";
    import axios from "axios";
    import VueController from "../../../public/js/controller";

    const v = Validator();

    export default {
        name: 'i-entity-table',
        components: {Validator},
        inheritAttrs: true,
        props: {
            column: {
                type: String,
                default: "12"
            },
            label: {
                type: String,
                default: ""
            },
            value: {
                type: Array,
                default: () => {
                    return []
                }
            },
            source: {
                type: String,
                default: ""
            },
            valueField: {
                type: String,
                default: ""
            },
            readonly: {
                type: Boolean,
                default: false
            },
            variable: {
                type: Object,
                default: () => {
                    return {}
                }
            },
        },
        watch: {
            value: function (data) {
                //console.log("udpated");
                if(data == this.value){
                    return;
                }
                this.loadData(this.source, this.valueField, this.value);
            },
            variable: function (data) {
                this.loadData(this.source, this.valueField, this.value);
            }

        },

        mounted() {
            this.loadData(this.source, this.valueField, this.value);
        },

        data: () => {
            return {
                values: {},
                model: {},
                items: [],
                headers: [],
                selectedData: null,
            }
        },
        methods: {
            loadData: function (sql, valueField, selectedData) {
                this.show = true;
                this.selectedData = selectedData;
                this.valueField = valueField;

                /*
                                //console.log("selectedData:" + selectedData);
                                //console.log("valueField:" + valueField);
                                //console.log("multiselect:" + multiselect);
                */
                //sql = this.normalizeSQL(sql);
                sql = encodeURI( FormJS.normalizeSQL(sql,this.variable));

                axios.post(process.env.VUE_APP_API_URL + "/workflow/getdata?sql=" + sql).then(data => {
                        if (data.length > 0) {
                            let ob = data[0];
                            let fields = [];
                            for (let key in ob) {
                                let field = {text: key, value: key, order: false};
                                fields.push(field);
                            }
                            this.headers = fields;
                            this.items = data;
                            this.$emit("input", this.items);
                        }
                    },
                    error => {

                    }
                );
            },

            formatData:function(value){
                if(DateUtils.checkIsDate(value)){
                    return DateUtils.displayDate(value,this.$t("lang.common.dateTimeFormat"));
                } else
                    return value;

            }
        }
    }
</script>
